import { Inject, Injectable } from '@angular/core';
import { CasiLogLevel } from '../common/logger.lib';
import { AppConfig, CONFIG_TOKEN } from '../setup/config';

const VOID_FUNCTION = (...data: any[]): void => { };

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  // debug = console.debug.bind(console.debug); //this.$console.debug; // console.debug.bind(console.debug);
  // log = console.debug.bind(console.debug); // this.$console.log; // console.log.bind(console.log);
  // info = console.info.bind(console.info); // this.$console.info; // console.info.bind(console.info);
  // error = console.error.bind(console.error); // this.$console.error; // console.error.bind(console.error);
  // warn = console.warn.bind(console.warn); //this.$console.warn; // console.warn.bind(console.warn);
  // clear = console.clear.bind(console.clear); //this.$console.clear;
  debug = console.log; // console.debug.bind(console.debug);
  log = console.log; // this.$console.log; // console.log.bind(console.log);
  info = console.info; // this.$console.info; // console.info.bind(console.info);
  error = console.error; // console.error.bind(console.error); // this.$console.error; // console.error.bind(console.error);
  warn = console.warn; // console.warn.bind(console.warn); //this.$console.warn; // console.warn.bind(console.warn);
  clear = console.clear; // console.clear.bind(console.clear); //this.$console.clear;

  constructor(
    @Inject(CONFIG_TOKEN) appConfig: AppConfig
  ) {
    console.log(`logger service: isDev: `, appConfig.isDev, appConfig.logLevel);
    if (appConfig.isDev) {
      switch (appConfig.logLevel) {
        case CasiLogLevel.Warning:
          this.debug = VOID_FUNCTION;
          this.info = VOID_FUNCTION;
          this.log = VOID_FUNCTION;
          this.error = VOID_FUNCTION;
          break;

        case CasiLogLevel.Error:
          this.debug = VOID_FUNCTION;
          this.info = VOID_FUNCTION;
          this.log = VOID_FUNCTION;
          break;
        case CasiLogLevel.Info:
          this.debug = VOID_FUNCTION;
          this.log = VOID_FUNCTION;
          break;
        // case CasiLogLevel.Log:
        //   this.debug = VOID_FUNCTION;
        //   break;
        default:
        // Do nothing :D
      }

    } else {
      this.debug = VOID_FUNCTION;
      this.info = VOID_FUNCTION;
    }
  }
}
